import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Statistics.module.scss'
import { getStatistics } from './Statistics.actions'
import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../Store/store'

export const Statistics: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const [statisticsHtml, setStatisticsHtml] = useState<string>('')
  const [error, setError] = useState<unknown>(null)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getStatistics())
      .then((action: any) => {
        if (action?.payload?.html) {
          setStatisticsHtml(action.payload.html)
        }
      })
      .catch(setError)
  }, [dispatch])

  return (
    <div className={`card ${styles.container}`}>
      {statisticsHtml ? (
        <iframe srcDoc={statisticsHtml} />
      ) : error ? (
        <p>{t('statistics_error')}</p>
      ) : (
        <p>{t('statistics_loading')}</p>
      )}
    </div>
  )
}
